import { bool, func, number, shape, string } from "prop-types";

/*
    If you change the structure in this file, you must check:
        CustomText.js and ExampleText.js

    (This will not break any component that is using
        CustomText if you just add keys)
*/

/* CustomText Data Structure Guide */
export const customMovementDetailDataStructureGuide = {
    dispatch: func.isRequired,
    movement: shape({
        idAccount: string,
        idStatement: number,
        note: string,
    }).isRequired,
    account: shape({
        productType: string,
        idProduct: string,
        permissions: shape(),
        currency: string,
        number: string,
        ownerName: string,
        productAlias: string,
    }).isRequired,
    fetching: bool,
    voucher: string.isRequired,
};

export const customMovementDetailPropType = {
    dispatch: func.isRequired,
    movement: shape({
        idAccount: string,
        idStatement: number,
        note: string,
    }).isRequired,
    account: shape({
        productType: string,
        idProduct: string,
        permissions: shape(),
        currency: string,
        number: string,
        ownerName: string,
        productAlias: string,
    }).isRequired,
    fetching: bool,
    voucher: string.isRequired,
};

export const defaultCustomMovementDetailPropType = {
    dispatch: func.isRequired,
    movement: {
        idAccount: "",
        idStatement: 0,
        note: "",
    },
    account: {
        productType: "",
        idProduct: "",
        permissions: {},
        currency: "",
        number: "",
        ownerName: "",
        productAlias: "",
    },
    fetching: false,
    voucher: "00",
};
